import { Routes } from '@angular/router';

import { RootComponent } from '../root/root.component';
import { ListComponent } from './list/list.component';
import { UserEditComponent } from './edit/edit.component';

import { AuthGuard } from '../auth.guard';

export const routing: Routes = [
  {
    path: 'user',
    component: RootComponent, canActivate: [AuthGuard],

    children: [
      { path: '', component: ListComponent },
      { path: 'list', component: ListComponent },
      { path: 'add', component: UserEditComponent },
      { path: 'edit/:userId', component: UserEditComponent },
    ]
  }
];
